module.exports = __webpack_public_path__ + "static/media/corporate-catering-3.07a8684f.jpg";